import { useState, useEffect, useCallback, useRef } from 'react';
import '../TimeKeeping.css';
import '../../../App.css';
import 'react-calendar/dist/Calendar.css'; // Import default calendar stylesheet
import { CreateButton } from '../../CommonObjects';
import { SetAuditTrail } from '../../Reports/AuditTrailReportEmployeeSetup';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import axios from '../../../api/apiClient';
import { token, domain } from '../../Security';
import 'react-tabs/style/react-tabs.css';
import * as XLSX from 'xlsx'; // Import all exports from xlsx library
import loadingSpinner from '../../../assets/loading.gif';

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
// icons
import SettingsIcon from '@mui/icons-material/Settings';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import AccessTimeFilledIcon from '@mui/icons-material/AccessTimeFilled';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { UploadTimeEntries } from './tabs/UploadTimeEntries';
import { ProcessedTimeEntries } from './tabs/ProcessedTimeEntries';
import { PostedTimeEntries } from './tabs/PostedTimeEntries';
import { SettingInit } from './components/SettingInit';
import { SelectLogsForm } from './TimeEntriesFormFld/SelectLogsForm';
import { RevertTimeEntriesForm } from './TimeEntriesFormFld/RevertTimeEntriesForm';
import { PayrollPeriodIdSelectFilter } from './formComponents/PayrollPeriodIdSelectFilter';
import { EmployeeGroup1IdSelect } from './formComponents/EmployeeGroup1IdSelect';
import { PayTypeIdSelect } from './formComponents/PayTypeIdSelect';
import { ClassificationIdSelectDummy, ClassificationSelectDummy } from './formComponents/ClassificationIdSelectDummy';
import { ClassificationIdSelectFilter } from './formComponents/ClassificationIdSelectFilter';
import { SectionIdSelect } from './formComponents/SectionIdSelect';
import { LocationIdSelect } from './formComponents/LocationIdSelect';
import { ProcessTimeEntriesForm } from './TimeEntriesFormFld/ProcessTimeEntriesForm';
import { PostTimeEntriesForm } from './TimeEntriesFormFld/PostTimeEntriesForm';
import { DeleteAllForm } from './TimeEntriesFormFld/DeleteAllForm';
import { UploadForm } from './TimeEntriesFormFld/UploadForm';
import { UploadFormTampered } from './TimeEntriesFormFld/UploadFormTampered';
import { EmployeeSelectFormLogs } from './TimeEntriesFormFld/EmployeeSelectFormLogs';
import { CustomLoader } from './components/CustomLoader';
import { FEATURES } from '../../../config/features';
import { Button, DepartmentIdSelectWithAll, EmployeeTypeIdSelectWithAll, VesselIdSelectWithAll } from '../../../common/APICommon';
import { PayTypeSelect } from '../../../common/selectComponents/PayTypeSelect';
import { ClassificationSelect } from '../../../common/selectComponents/ClassificationSelect';
import { PayrollPeriodSelect } from '../../../common/selectComponents/PayrollPeriodSelect';
import { LocationSelect } from '../../../common/selectComponents/LocationSelect';
import { SectionSelect } from '../../../common/selectComponents/SectionSelect';
import { EmployeeGroup1Select } from '../../../common/selectComponents/EmployeeGroup1Select';
import { useTimeEntries } from '../../../v2/hooks/useTimeEntries';

const TimeKeeping = ({ user, userAccess, isHideSideMenu }) => {
  const [showSetting, setShowSetting] = useState(false);
  const settingRef = useRef(null);
  const buttonRef = useRef(null);


  // -- New --
  const { prepareTemplateData, isProcessingTemplate } = useTimeEntries();

  // -- End new --
  const [loadingPercentage, setLoadingPercentage] = useState(0);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [loadingUploadRequest, setLoadingUploadRequest] = useState(false);
  const [loadingRequestProcess, setLoadingRequestProcess] = useState(false);
  // const [employees, setEmployees] = useState([]);
  const [dateTimeRecordData, setDateTimeRecordData] = useState([]);
  const [selectedDTR, setSelectedDTR] = useState([]);
  const [activeRowIds, setActiveRowIds] = useState([]); // Array to store active row IDs

  const [selectedTab, setSelectedTab] = useState(0);
  const [showSelectDataLogs, setShowSelectDataLogs] = useState(false);
  const [showRevertTimeForm, setShowRevertTimeForm] = useState(false);
  const [showProcessTimeForm, setShowProcessTimeForm] = useState(false);
  const [showPostTimeForm, setShowPostTimeForm] = useState(false);
  const [showDeleteAll, setShowDeleteAll] = useState(false);
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [showUploadTamperedForm, setShowUploadTamperedForm] = useState(false);
  const [isGenerate, setIsGenerate] = useState(false);
  const [generateMessage, setGenerateMessage] = useState(false);
  const [isRevert, setIsRevert] = useState(false);
  const [isProcess, setIsProcess] = useState(false);
  const [isPost, setIsPost] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isUpload, setIsUpload] = useState(false);
  const [isSelectLogs, setIsSelectLogs] = useState(false);

  //logs
  const [dateFromLogs, setDateFromLogs] = useState("");
  const [dateToLogs, setDateToLogs] = useState("");
  const [showEmployeeForm, setShowEmployeeForm] = useState(false);
  const [employeePersonalInformationIdLogs, setEmployeePersonalInformationIdLogs] = useState("");
  const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
  // const [employeeInfoLogs, setEmployeeInfoLogs] = useState([]);
  const [deviceLogs, setDeviceLogs] = useState("");

  const [classificationFilterForAdminHRHead, setClassificationFilterForAdminHRHead] = useState("");
  const [classificationFilterForHRAsst2, setClassificationFilterForHRAsst2] = useState("2");
  const [classificationFilterForHRAsst3, setClassificationFilterForHRAsst3] = useState("4");
  // const [dateFromLogs, setDateFromLogs] = useState("2022-07-01");
  // const [dateToLogs, setDateToLogs] = useState("2024-05-14");

  //filters
  const [filterPayrollPeriodId, setFilterPayrollPeriodId] = useState("");
  const [filterPayTypeId, setFilterPayTypeId] = useState("");
  const [filterClassificationId, setFilterClassificationId] = useState("");
  const [currentFilterClassificationId, setCurrentFilterClassificationId] = useState("");
  const [filterLocationId, setFilterLocationId] = useState("");
  const [filterSectionId, setFilterSectionId] = useState("");
  const [filterEmployeeGroup1Id, setFilterEmployeeGroup1Id] = useState("");
  const [filterDepartmentId, setFilterDepartmentId] = useState("");
  const [filterEmployeeTypeId, setFilterEmployeeTypeId] = useState("");
  const [filterVesselId, setFilterVesselId] = useState("");

  useEffect(() => {
    if (currentFilterClassificationId !== filterClassificationId) {
      setCurrentFilterClassificationId(filterClassificationId)
      setFilterLocationId("")
      setFilterSectionId("")
      setFilterEmployeeGroup1Id("")
      setFilterDepartmentId("")
      setFilterEmployeeTypeId("")
      setFilterVesselId("")
    }
  }, [currentFilterClassificationId, filterClassificationId])

  const [filterClassificationIdTimeEntries, setFilterClassificationIdTimeEntries] = useState("0");

  const [sectionFilter, setSectionFilter] = useState("0");
  const [locationFilter, setLocationFilter] = useState("0");
  const [departmentFilter, setDepartmentFilter] = useState("0");
  const [vesselFilter, setVesselFilter] = useState("0");
  const [employeeTypeFilter, setEmployeeTypeFilter] = useState("0");

  const [filterData, setFilterData] = useState([]);

  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  const [showRequestWarningMessage, setShowRequestWarningMessage] = useState(false);
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showRequestMessage]);
  useEffect(() => {
    if (showRequestWarningMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestWarningMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [showRequestWarningMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
          {form && (
            <div className="modal toggleMessage" style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}>
              <div className='column'>
                {isSuccess ?
                  <div className='request_title row' style={{ fontWeight: "bold", color: "green", alignItems: "center" }}>
                    <CheckCircleIcon />
                    <span >{"SUCCESS MESSAGE"}</span>
                  </div>
                  :
                  <div className='request_title row' style={{ fontWeight: "bold", color: "#DD5746", alignItems: "center" }}>
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                }
                <span style={{ textAlign: "center", padding: "10px 0", color: isSuccess ? "green" : "#DD5746" }}>{message}</span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  function GenerateWarningMessage({ form, message }) {
    return (
      <>
        <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
          {form && (
            <div className="modal toggleMessage warning-message" style={{ backgroundColor: "#ffd0c5" }}>
              <div className='column'>
                <div className='request_title row' style={{ fontWeight: "bold", color: "#DD5746", alignItems: "center" }}>
                  <ErrorIcon />
                  <span>{"WARNING MESSAGE"}</span>
                </div>
                <span style={{ textAlign: "center", padding: "10px 0", color: "#DD5746" }}>{message}</span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  const handleSelectChange = (index) => {
    setSelectedTab(index);
  };
  const handleSetting = () => {
    setShowSetting(!showSetting);
  };
  const handleGenerate = () => {
    if (!filterPayrollPeriodId || !filterPayTypeId || !filterClassificationId) {
      setGenerateMessage(true);
      return;
    }

    setIsGenerate(true);
  };

  const handleSelectDataLogs_main = async (event) => {
    event.preventDefault();

    setLoadingRequest(true);

    const apiUrlUserTimeLog = domain + `/api/EmployeeTimeRecord/select-logs`;

    let classifiedData = classificationFilterForAdminHRHead;

    const data = {
      dateFrom: dateFromLogs,
      dateTo: dateToLogs,
      classificationId: classifiedData
    };

    try {
      console.log("Sending POST request");  // Added logging
      await axios.post(apiUrlUserTimeLog, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      });
      setShowSelectDataLogs(false);
      // deleteBulk(event);

      await SetAuditTrail({
        setupArea: "Time Entries",
        actionTaken: "insert",
        field: "Select Data Logs",
        newValue: "-",
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });

      await fetchDataTimeEntries();
      setShowRequestMessage(true);
      setIsSuccess(true);
    } catch (error) {
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);

      // Detailed error logging
      if (error.response) {
        // The request was made and the server responded with a status code outside of the 2xx range
        console.error('Error response:', error.response);
        console.error('Error response data:', error.response.data);
        const errorMessage = error.response.data && error.response.data.message ? error.response.data.message : 'An error occurred.';
        setRequestMessage(errorMessage);
      } else if (error.request) {
        // The request was made but no response was received
        console.error('Error request:', error.request);
        setRequestMessage("No response received from the server.");
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Error message:', error.message);
        setRequestMessage("An error occurred while processing your request.");
      }
    }

    setLoadingRequest(false);
    setShowSelectDataLogs(false);
  };
  const handleSelectDataLogs = async (event) => {
    event.preventDefault();

    setLoadingRequest(true);

    const apiUrlUserTimeLog = domain + `/api/EmployeeTimeRecord/user-time-log-raw`;

    let classifiedData = classificationFilterForAdminHRHead;

    const data = {
      dateFrom: dateFromLogs,
      dateTo: dateToLogs,
      classificationId: classifiedData
    };

    try {
      console.log("Sending POST request");  // Added logging
      await axios.post(apiUrlUserTimeLog, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      });
      setShowSelectDataLogs(false);
      // deleteBulk(event);

      await SetAuditTrail({
        setupArea: "Time Entries",
        actionTaken: "insert",
        field: "Select Data Logs",
        newValue: "-",
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });

      await fetchDataTimeEntries();
      setShowRequestMessage(true);
      setIsSuccess(true);
    } catch (error) {
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);

      // Detailed error logging
      if (error.response) {
        // The request was made and the server responded with a status code outside of the 2xx range
        console.error('Error response:', error.response);
        console.error('Error response data:', error.response.data);
        const errorMessage = error.response.data && error.response.data.message ? error.response.data.message : 'An error occurred.';
        setRequestMessage(errorMessage);
      } else if (error.request) {
        // The request was made but no response was received
        console.error('Error request:', error.request);
        setRequestMessage("No response received from the server.");
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Error message:', error.message);
        setRequestMessage("An error occurred while processing your request.");
      }
    }

    setLoadingRequest(false);
    setShowSelectDataLogs(false);
  };
  const handleSelectDataLogs_Mobile = async (event) => {
    event.preventDefault();

    setLoadingRequest(true);

    const apiUrlUserTimeLog = domain + `/api/EmployeeTimeRecord/mobile-dtr`;

    let classifiedData = classificationFilterForAdminHRHead;

    const data = {
      dateFrom: dateFromLogs,
      dateTo: dateToLogs,
      classificationId: classifiedData
    };

    try {
      console.log("Sending POST request");  // Added logging
      await axios.post(apiUrlUserTimeLog, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      });
      setShowSelectDataLogs(false);
      // deleteBulk(event);

      await SetAuditTrail({
        setupArea: "Time Entries",
        actionTaken: "insert",
        field: "Select Data Logs",
        newValue: "-",
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });

      await fetchDataTimeEntries();
      setShowRequestMessage(true);
      setIsSuccess(true);
    } catch (error) {
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);

      // Detailed error logging
      if (error.response) {
        // The request was made and the server responded with a status code outside of the 2xx range
        console.error('Error response:', error.response);
        console.error('Error response data:', error.response.data);
        const errorMessage = error.response.data && error.response.data.message ? error.response.data.message : 'An error occurred.';
        setRequestMessage(errorMessage);
      } else if (error.request) {
        // The request was made but no response was received
        console.error('Error request:', error.request);
        setRequestMessage("No response received from the server.");
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Error message:', error.message);
        setRequestMessage("An error occurred while processing your request.");
      }
    }

    setLoadingRequest(false);
    setShowSelectDataLogs(false);
  };

  const handleDeleteAll = async (event) => {
    event.preventDefault();
    const apiUrl = domain + `/api/EmployeeTimeRecord`;
    setLoadingRequest(true);
    closeDeleteAll();

    if (dateTimeRecordData.length === 0) {
      setLoadingRequest(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("No record to delete");
      closeDeleteAll();
      return;
    }

    try {
      console.log("Sending POST request");  // Added logging
      await axios.post(apiUrl + `/bulk-delete`, dateTimeRecordData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
      });

      await SetAuditTrail({
        setupArea: "Time Entries",
        actionTaken: "delete",
        field: "Delete All Uploaded Time Entries",
        newValue: "-",
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });

      await fetchDataTimeEntries();

      setIsDelete(true);
      closeDeleteAll();
    } catch (error) {
      setLoadingRequest(false);
      console.error('Error:', error);
    } finally {
      setLoadingRequest(false);
    }

    setIsDelete(true);
  }
  useEffect(() => {
    if (generateMessage) {
      const timeoutId = setTimeout(() => {
        setGenerateMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }

  }, [generateMessage]);
  useEffect(() => {
    var settingIcon = document.getElementById("setting-icon");

    if (showSetting) {
      //change the down icon to up
      settingIcon.setAttribute("data-testid", "KeyboardArrowUpIcon"); //Up Arrow Test ID
      settingIcon.children[0].setAttribute("d", `M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z`); // Up Arrow.Path d attribute    
    } else {
      //change the up icon to down
      settingIcon.setAttribute("data-testid", "KeyboardArrowDownIcon"); // Down Arrow Test ID
      settingIcon.children[0].setAttribute("d", `M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z`); // Down Arrow.Path d attribute
    }

    const handleClickOutside = (event) => {
      if (settingRef.current && !settingRef.current.contains(event.target)) {
        if (buttonRef.current && !buttonRef.current.contains(event.target)) {
          setShowSetting(false);
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };


  }, [showSetting]);

  const [isGenerateUploadedTimeEntries, setIsGenerateUploadedTimeEntries] = useState(false);
  const [payrollPeriodUploadedTimeEntries, setPayrollPeriodUploadedTimeEntries] = useState("");
  const generateUploadedTimeEntries = () => {
    setIsGenerateUploadedTimeEntries(true);
  }

  //====================================================================================================
  //===============================TIME ENTRIES=========================================================
  //====================================================================================================
  // const [isSetEmployeesOnce, setIsSetEmployeesOnce] = useState(false);
  const [showTampered, setShowTampered] = useState(false);
  const fetchDataTimeEntries = useCallback(async () => {
    if (!isGenerateUploadedTimeEntries) {
      return;
    }

    let classificationFilter = filterClassificationIdTimeEntries;

    let apiUrlFetch = "";

    if (
      FEATURES.TIMEKEEPING_EMPLOYEETYPE
      && FEATURES.TIMEKEEPING_VESSEL) {
      apiUrlFetch = domain + `/api/EmployeeTimeRecord/classification/${classificationFilter}/department/${departmentFilter}/vessel/${vesselFilter}/employeeType/${employeeTypeFilter}/payrollperiod/${payrollPeriodUploadedTimeEntries}`;
    } else {
      apiUrlFetch = domain + `/api/EmployeeTimeRecord/classification/${classificationFilter}/section/${sectionFilter}/location/${locationFilter}/payrollperiod/${payrollPeriodUploadedTimeEntries}`
    }

    try {
      console.log(`Fetching time entries....:: ${apiUrlFetch}`);
      // return;
      setLoadingRequest(true);
      const response = await axios.get(apiUrlFetch, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })

      setIsRevert(false);
      setIsProcess(false);
      setIsPost(false);
      setIsDelete(false);
      setIsUpload(false);
      setIsSelectLogs(false);

      setDateTimeRecordData(response.data); // Set the response data to the state
      setFilterData(response.data); // Set the response data to the state
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoadingRequest(false);
    } finally {
      setLoadingRequest(false); // Set loading state to false after data fetching is complete
    }
  }, [
    filterClassificationIdTimeEntries,
    sectionFilter,
    locationFilter,
    isGenerateUploadedTimeEntries,
    payrollPeriodUploadedTimeEntries,
    employeeTypeFilter,
    vesselFilter,
    departmentFilter
  ]);
  //====================================================================================================
  //===============================TIME ENTRIES=========================================================
  //====================================================================================================

  //====================================================================================================
  //===============================PROCESSED TIME ENTRIES===============================================
  //====================================================================================================
  const [loadingSummaryProcessed, setLoadingSummaryProcessed] = useState(false);
  const [loadingDetailedProcessed, setLoadingDetailedProcessed] = useState(false);
  const [filterDataSummaryProcessed, setFilterDataSummaryProcessed] = useState([]);
  const [filterDataDetailedProcessed, setFilterDataDetailedProcessed] = useState([]);
  const [dateTimeRecordDataSummaryProcessed, setDateTimeRecordDataSummaryProcessed] = useState([]);
  const [dateTimeRecordDataDetailedProcessed, setDateTimeRecordDataDetailedProcessed] = useState([]);

  const fetchDataSummaryProcessed = useCallback(async () => {
    // 1. Configuration: Add new path parameters here easily
    const pathSegments = {
      paytype: filterPayTypeId,
      payrollperiod: filterPayrollPeriodId,
      classification: filterClassificationId,
      location: filterLocationId || 0,
      section: filterSectionId || 0,
      employeeGroup1: filterEmployeeGroup1Id || 0,
      department: filterDepartmentId || 0,
      employeeType: filterEmployeeTypeId || 0,
      vessel: filterVesselId || 0,
    };

    // 2. Validation
    const hasRequiredFields = filterPayTypeId && filterPayrollPeriodId && filterClassificationId;
    if (!isGenerate || !hasRequiredFields) return;

    try {
      setLoadingSummaryProcessed(true);

      // 3. Construct URL dynamically: /paytype/1/payrollperiod/5/.../summary
      const pathString = Object.entries(pathSegments)
        .map(([key, value]) => `${key}/${value}`)
        .join('/');

      const url = `${domain}/api/DateTimeRecordStaging/${pathString}/summary`;
      
      console.log({ pathString, url });

      const response = await axios.get(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log("dateTimeRecordDataSummaryProcessed: ", response.data);
      setDateTimeRecordDataSummaryProcessed(response.data);
      setFilterDataSummaryProcessed(response.data);

    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoadingSummaryProcessed(false);
    }
  }, [
    domain, token, isGenerate,
    filterPayTypeId, filterPayrollPeriodId, filterClassificationId,
    filterLocationId, filterSectionId, filterEmployeeGroup1Id,
    filterDepartmentId, filterEmployeeTypeId,
    filterVesselId
  ]);
  const fetchDataDetailedProcessed = useCallback(async () => {
    // 1. URL Configuration - Add new segments here
    const pathSegments = {
      paytype: filterPayTypeId,
      payrollperiod: filterPayrollPeriodId,
      classification: filterClassificationId,
      location: filterLocationId || 0,
      section: filterSectionId || 0,
      employeeGroup1: filterEmployeeGroup1Id || 0,
      department: filterDepartmentId || 0,
      employeeType: filterEmployeeTypeId || 0,
      vessel: filterVesselId || 0
    };

    // 2. Logic Gates (Validation)
    const hasRequiredFilters = filterPayTypeId && filterPayrollPeriodId && filterClassificationId;
    if (!isGenerate || !hasRequiredFilters) return;

    try {
      setLoadingDetailedProcessed(true);

      // 3. Construct the URL path dynamically
      const pathString = Object.entries(pathSegments)
        .map(([key, value]) => `${key}/${value}`)
        .join('/');

      const url = `${domain}/api/DateTimeRecordStaging/${pathString}/detailed`;

      const response = await axios.get(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log("dateTimeRecordDataDetailedProcessed: ", response.data);
      setDateTimeRecordDataDetailedProcessed(response.data);
      setFilterDataDetailedProcessed(response.data);

    } catch (error) {
      console.error('Error fetching detailed data:', error);
    } finally {
      setLoadingDetailedProcessed(false);
    }
  }, [
    domain, token, isGenerate,
    filterPayTypeId, filterPayrollPeriodId, filterClassificationId,
    filterLocationId, filterSectionId, filterEmployeeGroup1Id,
    filterDepartmentId, filterEmployeeTypeId,
    filterVesselId
  ]);
  //====================================================================================================
  //===============================PROCESSED TIME ENTRIES===============================================
  //====================================================================================================

  //====================================================================================================
  //===============================POSTED TIME ENTRIES==================================================
  //====================================================================================================
  const [loadingSummaryPosted, setLoadingSummaryPosted] = useState(false);
  const [loadingDetailedPosted, setLoadingDetailedPosted] = useState(false);
  const [filterDataSummaryPosted, setFilterDataSummaryPosted] = useState([]);
  const [filterDataDetailedPosted, setFilterDataDetailedPosted] = useState([]);
  const [dateTimeRecordDataSummaryPosted, setDateTimeRecordDataSummaryPosted] = useState([]);
  const [dateTimeRecordDataDetailedPosted, setDateTimeRecordDataDetailedPosted] = useState([]);

  const fetchDataSummaryPosted = useCallback(async () => {
    // 1. URL Configuration - Add new segments (like department) here
    const pathSegments = {
      paytype: filterPayTypeId,
      payrollperiod: filterPayrollPeriodId,
      classification: filterClassificationId,
      location: filterLocationId || 0,
      section: filterSectionId || 0,
      employeeGroup1: filterEmployeeGroup1Id || 0,
      department: filterDepartmentId || 0,
      employeeType: filterEmployeeTypeId || 0,
      vessel: filterVesselId || 0
    };

    // 2. Logic Gates
    const hasRequiredFields = filterPayTypeId && filterPayrollPeriodId && filterClassificationId;
    if (!isGenerate || !hasRequiredFields) return;

    try {
      setLoadingSummaryPosted(true);

      // 3. Construct URL dynamically
      const pathString = Object.entries(pathSegments)
        .map(([key, value]) => `${key}/${value}`)
        .join('/');

      // Base URL is slightly different here: /api/DateTimeRecord
      const url = `${domain}/api/DateTimeRecord/${pathString}/summary`;

      const response = await axios.get(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      setDateTimeRecordDataSummaryPosted(response.data);
      setFilterDataSummaryPosted(response.data);

    } catch (error) {
      console.error('Error fetching summary posted data:', error);
    } finally {
      setLoadingSummaryPosted(false);
    }
  }, [
    domain, token, isGenerate,
    filterPayTypeId, filterPayrollPeriodId, filterClassificationId,
    filterLocationId, filterSectionId, filterEmployeeGroup1Id,
    filterDepartmentId, filterEmployeeTypeId,
    filterVesselId
  ]);
  const fetchDataDetailedPosted = useCallback(async () => {
    // 1. URL Configuration - Add new path variables here
    const pathSegments = {
      paytype: filterPayTypeId,
      payrollperiod: filterPayrollPeriodId,
      classification: filterClassificationId,
      location: filterLocationId || 0,
      section: filterSectionId || 0,
      employeeGroup1: filterEmployeeGroup1Id || 0,
      department: filterDepartmentId || 0,
      employeeType: filterEmployeeTypeId || 0,
      vessel: filterVesselId || 0
    };

    // 2. Validation Logic
    const hasRequiredFilters = filterPayTypeId && filterPayrollPeriodId && filterClassificationId;
    if (!isGenerate || !hasRequiredFilters) return;

    try {
      setLoadingDetailedPosted(true);

      // 3. Dynamic URL Construction
      const pathString = Object.entries(pathSegments)
        .map(([key, value]) => `${key}/${value}`)
        .join('/');

      const url = `${domain}/api/DateTimeRecord/${pathString}/detailed`;

      const response = await axios.get(url, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log("dateTimeRecordDataDetailedPosted: ", response.data);
      setDateTimeRecordDataDetailedPosted(response.data);
      setFilterDataDetailedPosted(response.data);

    } catch (error) {
      console.error('Error fetching detailed posted data:', error);
    } finally {
      setLoadingDetailedPosted(false);
    }
  }, [
    domain, token, isGenerate,
    filterPayTypeId, filterPayrollPeriodId, filterClassificationId,
    filterLocationId, filterSectionId, filterEmployeeGroup1Id,
    filterDepartmentId, filterEmployeeTypeId,
    filterVesselId
  ]);
  //====================================================================================================
  //===============================POSTED TIME ENTRIES==================================================
  //====================================================================================================

  const openSelectDataLogs = () => {
    setShowSelectDataLogs(true);
  }
  const closeSelectDataLogs = () => {
    setShowSelectDataLogs(false);
  }
  const openRevertTimeForm = () => {
    setShowRevertTimeForm(true);
  }
  const closeRevertTimeForm = () => {
    setShowRevertTimeForm(false);
  }
  const openProcessTimeForm = () => {
    setShowProcessTimeForm(true);
  }
  const closeProcessTimeForm = () => {
    setShowProcessTimeForm(false);
  }
  const openPostTimeForm = () => {
    setShowPostTimeForm(true);
  }
  const closePostTimeForm = () => {
    setShowPostTimeForm(false);
  }
  const openDeleteAll = () => {
    setShowDeleteAll(true);
  }
  const closeDeleteAll = () => {
    setShowDeleteAll(false);
  }
  const openUploadFormHandleClick = () => {
    setShowUploadForm(true);
  }
  const closeUploadFormHandleClick = () => {
    setShowUploadForm(false);
  }
  const openUploadTamperedFormHandleClick = () => {
    setShowUploadTamperedForm(true);
  }
  const closeUploadTamperedFormHandleClick = () => {
    setShowUploadTamperedForm(false);
  }
  const closeEmployeeForm = () => {
    setShowEmployeeForm(false);
  };
  /* const underMaintenance = () =>{
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("This is under maintenance");
  } */

  //settings buttons
  const generateDownloadTemplate = async () => {
    // ADDED: Simple guard clause
    if (isProcessingTemplate) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('DTR'); // Named worksheet

    const header = [
      'EmployeeId',
      'EmployeeName',
      'Date',
      'TimeIn',
      'DeviceNameIn',
      'TimeOut',
      'DeviceNameOut'
    ];

    const headerRow = worksheet.addRow(header);
    worksheet.columns = [
      { key: 'employeeId', width: 20 },
      { key: 'fullName', width: 35 },
      { key: 'date', width: 15 },
      { key: 'timeIn', width: 15 },
      { key: 'deviceNameTimeIn', width: 20 },
      { key: 'timeOut', width: 15 },
      { key: 'deviceNameTimeOut', width: 20 },
    ];

    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: 'center' };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '92d050' } };
    });

    // Determine if we should populate or show sample
    if (payrollPeriodUploadedTimeEntries && filterClassificationIdTimeEntries) {
      // Prepare data using the updated hook logic
      const templateData = await prepareTemplateData(payrollPeriodUploadedTimeEntries, filterClassificationIdTimeEntries);

      if (templateData && templateData.length > 0) {
        templateData.forEach(row => {
          worksheet.addRow([
            row.employeeId,
            row.fullName,
            row.date,
            '', // TimeIn (Empty for user input)
            '', // DeviceNameIn
            '', // TimeOut
            ''  // DeviceNameOut
          ]);
        });
      } else {
        // REPLACED: Better placeholder if filter returns nothing
        worksheet.addRow(['NO_ACTIVE_EMPLOYEES_FOUND', 'Check Classification Filter', '', '', '', '', '']);
      }
    } else {
      // Original Default Behavior for generic download
      worksheet.addRow(['<EMP1234>', '<LastName, FirstName>', '<MM/DD/YYYY>', '<hh:mm AM/PM>', '<Device1>', '<hh:mm AM/PM>', '<Device1>']);
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

    // ADDED: Dynamic filename based on date if available
    const fileName = payrollPeriodUploadedTimeEntries ? `DTR_Template_Class${filterClassificationIdTimeEntries}.xlsx` : 'DTRTemplate.xlsx';
    saveAs(blob, fileName);
  };

  const fetchAllEmployees = async () => {
    const apiUrl = domain + "/api/Employee/masterlist";
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })

      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      return [];
    }
  };

  const convertToDateTime = (value) => {
    if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
      return null;
    }

    if (!value) {
      return null;
    }

    if (typeof value === 'number') {
      // Convert Excel serial number to JavaScript Date
      const excelStartDate = new Date(1899, 11, 31); // Correct base date
      const jsDate = new Date(excelStartDate.getTime() + value * 86400000); // Convert days to milliseconds

      return jsDate.toISOString().split('T')[0];
    }

    if (typeof value === 'string') {
      let formattedValue = value.replace(/-/g, '/'); // Ensure compatibility

      const parts = formattedValue.split('/');
      if (parts.length === 3) {
        let [first, second, third] = parts.map(p => parseInt(p, 10));

        let year, month, day;

        if (third > 31) {
          // Case: YYYY/MM/DD (Ensure proper year detection)
          year = third;
          month = first;
          day = second;
        } else if (first > 12) {
          // Case: DD/MM/YYYY (Auto-detect)
          day = first;
          month = second;
          year = third;
        } else {
          // Case: MM/DD/YYYY (US format)
          month = first;
          day = second;
          year = third;
        }

        return new Date(Date.UTC(year, month - 1, day)).toISOString().split('T')[0]; // Return YYYY-MM-DD
      }
    }

    return null
  }
  const convertToTime = (value, date) => {
    if (value === null || value === undefined || value === '' ||
      (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
      return null;
    }

    if (!value) {
      return null;
    }

    if (typeof value === 'number') {
      // Convert Excel serial number to JavaScript Date (Handles time values)
      const totalMilliseconds = value * 86400000; // Convert Excel days to milliseconds
      const hours = Math.floor((totalMilliseconds % 86400000) / 3600000); // Get hours
      const minutes = Math.floor((totalMilliseconds % 3600000) / 60000); // Get minutes

      // Format time as HH:mm (24-hour format)
      const formattedTime = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;

      // Combine with provided date (assumed in YYYY-MM-DD format)
      return `${date}T${formattedTime}`;
    }

    if (typeof value === 'string') {
      // Handle direct string inputs like "7:00 AM"
      const timeMatch = value.match(/(\d{1,2}):(\d{2})\s?(AM|PM)?/i);
      if (timeMatch) {
        let hour = parseInt(timeMatch[1], 10);  // First capturing group: HH
        let minute = parseInt(timeMatch[2], 10); // Second capturing group: MM
        let period = timeMatch[3]?.toUpperCase(); // Third capturing group: AM/PM

        // Convert 12-hour format to 24-hour format
        if (period === 'PM' && hour !== 12) {
          hour += 12;
        }
        if (period === 'AM' && hour === 12) {
          hour = 0;
        }

        // Format as HH:mm (24-hour format)
        const formattedTime = `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`;

        return `${date}T${formattedTime}`;
      }
    }

    return null;
  };

  const [uploadTimeEntries, setUploadTimeEntries] = useState([]);
  const uploadTimeEntriesFunc = async (file) => {
    setLoadingUploadRequest(true);
    const employees = await fetchAllEmployees();

    function sanitizeValue(value) {
      if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
        return '';
      }
      return value;
    }
    function validateData(data) {
      let newData = [];

      data.forEach((item, index) => {
        const missing = [];

        if (!item.employeePersonalInformationEmployeeId) missing.push('Employee Id');
        if (!item.date) missing.push('Date');

        // ✅ Construct error message properly
        let errorMessage = "";

        const existingEmployee = employees.find(employee => employee.employeeId === item.employeePersonalInformationEmployeeId?.toString());
        if (!existingEmployee) {
          errorMessage += errorMessage.length > 0 ? ` Employee Id does not exist.` : `Employee Id does not exist. `;
        }

        if (missing.length > 0) {
          errorMessage += ` Missing fields - ${missing.join(', ')}`;
        }

        newData.push({ ...item, errors: errorMessage });
      });

      newData.sort((a, b) => (a.error ? -1 : 1) - (b.error ? -1 : 1));

      return newData;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      const parseWorksheet = (worksheet) => {
        return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
      };

      const informations = parseWorksheet(workbook.Sheets[workbook.SheetNames[0]]);

      let bulkData = [];

      informations.forEach(info => {
        const existingEmployee = employees.find(employee => employee.employeeId === info.EmployeeId?.toString());

        bulkData.push({
          employeePersonalInformationId: existingEmployee ? existingEmployee.id : null,
          employeePersonalInformationEmployeeId: sanitizeValue(info.EmployeeId).toString(),
          employeePersonalInformationFullName: sanitizeValue(info.EmployeeName),
          date: convertToDateTime(info.Date),
          timeIn: convertToTime(info.TimeIn, convertToDateTime(info.Date)),
          deviceNameTimeIn: sanitizeValue(info.DeviceNameIn),
          timeOut: convertToTime(info.TimeOut, convertToDateTime(info.Date)),
          deviceNameTimeOut: sanitizeValue(info.DeviceNameOut),
          createdDate: new Date()
        });
      })

      const validatedData = validateData(bulkData)
      const sortedData = validatedData.sort((a, b) => {
        const hasErrorA = a.errors && a.errors.length > 0;
        const hasErrorB = b.errors && b.errors.length > 0;

        return hasErrorB - hasErrorA; // Move items with errors to the top
      });
      setUploadTimeEntries(sortedData)
    };

    setLoadingUploadRequest(false);
    reader.readAsArrayBuffer(file);
  }
  const handleFileUpload = async (files) => {
    if (!files || files.length === 0) {
      console.error('No files selected');
      return;
    }

    const file = files[0];
    uploadTimeEntriesFunc(file);

  }
  const handleFinalFileUpload = async (bulkData) => {
    setLoadingRequest(true);

    const apiUrl = domain + "/api/EmployeeTimeRecord/bulk";

    try {
      axios.post(apiUrl, bulkData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      await SetAuditTrail({
        setupArea: "Time Entries",
        actionTaken: "insert",
        field: "Upload Time Entries",
        newValue: "-",
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });

      setTimeout(async () => {
        await fetchDataTimeEntries();
        await fetchDataSummaryPosted();
        await fetchDataDetailedPosted();
      }, 1000);

      setShowRequestMessage(true);
      setIsSuccess(true);
      setIsUpload(true);
    } catch (error) {
      console.error('Error posting data to API:', error);
      setShowRequestMessage(true);
      setIsSuccess(false);

      if (error.response && error.response.data && error.response.data.errors) {
        const errorMessage = error.response.data.errors["$"][0]; // Accessing the error message
        setRequestMessage(errorMessage);
      } else if (error.response && error.response.data && error.response.data.message) {
        const errorMessage = error.response.data.message; // Fallback to general message
        setRequestMessage(errorMessage);
      } else {
        setRequestMessage("An unknown error occurred."); // Default message
      }
    } finally {
      setLoadingRequest(false);
    }
  }

  const [uploadTamperedEntries, setUploadTamperedEntries] = useState([]);
  const uploadTamperedFunc = async (file) => {
    setLoadingUploadRequest(true);
    const employees = await fetchAllEmployees();

    function sanitizeValue(value) {
      if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
        return '';
      }
      return value;
    }
    function sanitizeValueNull(value) {
      if (value === null || value === undefined || value === '' || (typeof value === 'string' && value.startsWith('<') && value.endsWith('>'))) {
        return null;
      }
      return value;
    }
    function validateData(data) {
      let newData = [];

      console.log(data)

      data.forEach((item, index) => {
        const missing = [];

        if (!item.id) missing.push('Id');
        if (!item.employeePersonalInformationEmployeeId) missing.push('Employee Id');
        if (!item.date) missing.push('Date');
        // if (!item.reasonForTampering) missing.push('Reason For Tampering');

        // ✅ Construct error message properly
        let errorMessage = "";

        const existingEmployee = employees.find(employee => employee.employeeId === item.employeePersonalInformationEmployeeId?.toString());
        if (!existingEmployee) {
          errorMessage += errorMessage.length > 0 ? ` Employee Id does not exist.` : `Employee Id does not exist. `;
        }

        const existindId = dateTimeRecordData.find(dtr => dtr.id?.toString() === item.id?.toString());
        if (!existindId) {
          errorMessage += errorMessage.length > 0 ? ` Id does not exist.` : `Id does not exist. `;
        }

        if (missing.length > 0) {
          errorMessage += ` Missing fields - ${missing.join(', ')}`;
        }

        newData.push({ ...item, errors: errorMessage });
      });

      newData.sort((a, b) => (a.error ? -1 : 1) - (b.error ? -1 : 1));

      return newData;
    }

    const reader = new FileReader();
    reader.onload = async (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: 'array' });

      const parseWorksheet = (worksheet) => {
        return XLSX.utils.sheet_to_json(worksheet, { defval: '' });
      };

      const informations = parseWorksheet(workbook.Sheets[workbook.SheetNames[0]]);

      let bulkData = [];

      informations.forEach(info => {
        bulkData.push({
          id: sanitizeValueNull(info.Id),
          employeePersonalInformationEmployeeId: sanitizeValue(info.EmployeeId).toString(),
          employeePersonalInformationFullName: sanitizeValue(info.Name),
          date: convertToDateTime(info.Date),
          timeIn: convertToTime(info.TimeIn, convertToDateTime(info.Date)),
          deviceNameTimeIn: sanitizeValue(info.DeviceIn),
          timeOut: convertToTime(info.TimeOut, convertToDateTime(info.Date)),
          deviceNameTimeOut: sanitizeValue(info.DeviceOut),
          employeePersonalInformationEmployeeInformationShiftScheduleShiftName: sanitizeValue(info.ShiftName),
          reasonForTampering: sanitizeValue(info.ReasonForTampering)
        });
      })

      const validatedData = validateData(bulkData)
      const sortedData = validatedData.sort((a, b) => {
        const hasErrorA = a.errors && a.errors.length > 0;
        const hasErrorB = b.errors && b.errors.length > 0;

        return hasErrorB - hasErrorA; // Move items with errors to the top
      });
      setUploadTamperedEntries(sortedData)
    };

    setLoadingUploadRequest(false);
    reader.readAsArrayBuffer(file);
  }
  const handleFileUploadTampered = async (files) => {
    if (!files || files.length === 0) {
      console.error('No files selected');
      return;
    }

    const file = files[0];
    uploadTamperedFunc(file);
  }
  const handleFinalFileUploadTampered = async (bulkData) => {
    setLoadingRequest(true);

    const apiUrl = domain + "/api/EmployeeTimeRecord/bulk-update-tampering";

    try {
      axios.post(apiUrl, bulkData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      await SetAuditTrail({
        setupArea: "Time Entries",
        actionTaken: "insert",
        field: "Upload Tampered Entries",
        newValue: "-",
        oldValue: "-",
        dateSaved: new Date(),
        savedById: user.id
      });

      await fetchDataTimeEntries();

      setShowRequestMessage(true);
      setIsSuccess(true);
      setIsUpload(true);
    } catch (error) {
      console.error('Error posting data to API:', error);
      setShowRequestMessage(true);
      setIsSuccess(false);

      if (error.response && error.response.data && error.response.data.errors) {
        const errorMessage = error.response.data.errors["$"][0]; // Accessing the error message
        setRequestMessage(errorMessage);
      } else if (error.response && error.response.data && error.response.data.message) {
        const errorMessage = error.response.data.message; // Fallback to general message
        setRequestMessage(errorMessage);
      } else {
        setRequestMessage("An unknown error occurred."); // Default message
      }
    } finally {
      setLoadingRequest(false);
    }
  }

  const [currentFilterPayTypeIdPayTypeId, setCurrentFilterPayTypeIdPayTypeId] = useState("");
  useEffect(() => {
    if (currentFilterPayTypeIdPayTypeId !== filterPayTypeId) {
      setCurrentFilterPayTypeIdPayTypeId(filterPayTypeId);
      setFilterClassificationId("");
      setFilterPayrollPeriodId("");
    }
  }, [currentFilterPayTypeIdPayTypeId, filterPayTypeId])

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="TimeInfo shadow-xl">
            <div className='sub-title row' style={{ padding: "5px 20px" }}>
              <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>{"Time Keeping >"} </span>
              <span style={{ borderBottom: "1px solid black" }}>{"Time Entries"}</span>
            </div>
            <div className="timeHeader row" style={{ justifyContent: "space-between", alignItems: "center" }}>
              <div className="tHeaderTitle row">
                <AccessTimeFilledIcon style={{ padding: "0 10px 0 0" }} />
                <h3>Time Entries</h3>
              </div>
              <div style={{ width: "30%", textAlign: "right" }}>
                <button ref={buttonRef} onClick={handleSetting} title="Setting" type="button" className="setting">
                  <SettingsIcon />
                  <KeyboardArrowDownIcon id="setting-icon" />
                </button>
                <div ref={settingRef}>
                  {showSetting &&
                    <SettingInit
                      user={user}
                      generateDownloadTemplate={generateDownloadTemplate}
                      openSelectDataLogs={openSelectDataLogs}
                      // openSelectDataLogs={underMaintenance}
                      openRevertTimeForm={openRevertTimeForm}
                      openProcessTimeForm={openProcessTimeForm}
                      openPostTimeForm={openPostTimeForm}
                      openDeleteAll={openDeleteAll}
                      openUploadFormHandleClick={openUploadFormHandleClick}
                    />}
                </div>

              </div>
            </div>
            <div className="mainData">
              <Tabs selectedIndex={selectedTab} onSelect={index => handleSelectChange(index)}
                // check user access for accounting roles to hide the tabs
                style={{
                  display:
                    userAccess.description === "Accounting"
                      || userAccess.description === "Accounting Head"
                      || userAccess.description === "Accounting Assistant" ?
                      "none" : "block"
                }}>
                <TabList>
                  <Tab><b>UPLOAD TIME ENTRIES</b></Tab>
                  <Tab><b>PROCESSED TIME ENTRIES</b></Tab>
                  <Tab><b>POSTED TIME ENTRIES</b></Tab>
                </TabList>
                <div className="timeKeepingTab">
                  <TabPanel>
                    <UploadTimeEntries
                      dateTimeRecordData={dateTimeRecordData}
                      setDateTimeRecordData={setDateTimeRecordData}
                      // employees={employees}
                      isRevert={isRevert}
                      isProcess={isProcess}
                      isPost={isPost}
                      isDelete={isDelete}
                      isUpload={isUpload}
                      setIsRevert={setIsRevert}
                      setIsProcess={setIsProcess}
                      setIsPost={setIsPost}
                      setIsDelete={setIsDelete}
                      setIsUpload={setIsUpload}
                      selectedDTR={selectedDTR}
                      setSelectedDTR={setSelectedDTR}
                      activeRowIds={activeRowIds}
                      setActiveRowIds={setActiveRowIds}
                      openUploadTamperedFormHandleClick={openUploadTamperedFormHandleClick}
                      isSelectLogs={isSelectLogs}
                      setIsSelectLogs={setIsSelectLogs}
                      userAccess={userAccess}
                      user={user}
                      filterData={filterData}
                      fetchData={fetchDataTimeEntries}
                      sectionFilter={sectionFilter}
                      setSectionFilter={setSectionFilter}
                      locationFilter={locationFilter}
                      employeeTypeFilter={employeeTypeFilter}
                      setEmployeeTypeFilter={setEmployeeTypeFilter}
                      vesselFilter={vesselFilter}
                      setVesselFilter={setVesselFilter}
                      departmentFilter={departmentFilter}
                      setDepartmentFilter={setDepartmentFilter}
                      setLocationFilter={setLocationFilter}
                      filterClassificationId={filterClassificationIdTimeEntries}
                      setFilterClassificationId={setFilterClassificationIdTimeEntries}
                      showTampered={showTampered}
                      setShowTampered={setShowTampered}

                      payrollPeriodUploadedTimeEntries={payrollPeriodUploadedTimeEntries}
                      setPayrollPeriodUploadedTimeEntries={setPayrollPeriodUploadedTimeEntries}
                      generateUploadedTimeEntries={generateUploadedTimeEntries}
                    />
                  </TabPanel>
                  {/* Processed Time Entries FILTER */}
                  <TabPanel>
                    <div className="rounded-lg bg-white p-4 shadow-sm" style={{ border: '1px solid #d1d5db' }}>
                      <div className="py-1">
                        <h4 className="font-medium text-gray-500 mt-0 mb-2">Filter</h4>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 pb-3 pt-3">
                        <div>
                          <PayTypeSelect
                            label="Pay Type"
                            payTypeId={filterPayTypeId}
                            setPayTypeId={setFilterPayTypeId}
                          />
                          <span style={{
                            visibility: "hidden",
                            color: "#ff6565",
                            fontSize: "12px"
                          }}>Please fill up Pay Type first
                          </span>
                        </div>
                        <div className="">
                          <PayrollPeriodSelect
                            label="Payroll Period"
                            value={filterPayrollPeriodId}
                            setValue={setFilterPayrollPeriodId}
                            hasPayTypeId={true}
                            payTypeId={filterPayTypeId}
                            isEditMode={!filterPayTypeId}
                          />

                          <span style={{
                            visibility: !filterPayTypeId ? "visible" : "hidden",
                            color: "#ff6565",
                            fontSize: "12px"
                          }}>Please fill up Pay Type first
                          </span>
                        </div>
                        {userAccess.length <= 0 &&
                          <div className="">
                            <div className="info-item-label">Classification Type</div>
                            <div className="info-item-input">
                              <ClassificationSelectDummy />
                            </div>
                            <span style={{
                              visibility: "hidden",
                              color: "#ff6565",
                              fontSize: "12px"
                            }}>Please fill up Pay Type first
                            </span>
                          </div>
                        }
                        <div className="">

                          <ClassificationSelect
                            label="Classification"
                            value={filterClassificationId}
                            setValue={setFilterClassificationId}
                            payTypeId={filterPayTypeId}
                            user={user}
                          />

                          <span style={{
                            visibility: !filterPayTypeId ? "visible" : "hidden",
                            color: "#ff6565",
                            fontSize: "12px"
                          }}>Please fill up Pay Type first
                          </span>
                        </div>

                        {FEATURES.TIMEKEEPING_EMPLOYEETYPE && (
                          <div className="">
                            <DepartmentIdSelectWithAll
                              label="Department"
                              value={filterDepartmentId}
                              setValue={setFilterDepartmentId}
                              isEditable={true}
                              disabled={!filterPayTypeId} />

                            <span style={{
                              visibility: !filterPayTypeId ? "visible" : "hidden",
                              color: "#ff6565",
                              fontSize: "12px"
                            }}>Please fill up Pay Type first
                            </span>
                          </div>
                        )}
                        {FEATURES.TIMEKEEPING_EMPLOYEETYPE && (
                          <div className="">
                            <EmployeeTypeIdSelectWithAll
                              label="Employee Type"
                              value={filterEmployeeTypeId}
                              setValue={setFilterEmployeeTypeId}
                              isEditable={true}
                              disabled={!filterPayTypeId} />

                            <span style={{
                              visibility: !filterPayTypeId ? "visible" : "hidden",
                              color: "#ff6565",
                              fontSize: "12px"
                            }}>Please fill up Pay Type first
                            </span>
                          </div>
                        )}
                        {FEATURES.TIMEKEEPING_EMPLOYEETYPE && (
                          <div className="">
                            <VesselIdSelectWithAll
                              label="Vessel"
                              value={filterVesselId}
                              setValue={setFilterVesselId}
                              isEditable={true}
                              disabled={!filterPayTypeId} />

                            <span style={{
                              visibility: !filterPayTypeId ? "visible" : "hidden",
                              color: "#ff6565",
                              fontSize: "12px"
                            }}>Please fill up Pay Type first
                            </span>
                          </div>
                        )}
                      </div>


                      <Button
                        name={"GENERATE"}
                        icon={<RestartAltIcon />}
                        onClick={handleGenerate}
                        className={"bg-blue-800 hover:bg-blue-900 text-white border-none cursor-pointer"}
                      />
                    </div>
                    <ProcessedTimeEntries
                      filterPayrollPeriodId={filterPayrollPeriodId}
                      filterPayTypeId={filterPayTypeId}
                      filterClassificationId={filterClassificationId}
                      filterLocationId={filterLocationId}
                      filterSectionId={filterSectionId}
                      userAccess={userAccess}
                      isGenerate={isGenerate}
                      isRevert={isRevert}
                      isProcess={isProcess}
                      isPost={isPost}
                      loadingSummary={loadingSummaryProcessed}
                      loadingDetailed={loadingDetailedProcessed}
                      fetchDataSummary={fetchDataSummaryProcessed}
                      fetchDataDetailed={fetchDataDetailedProcessed}
                      filterDataSummary={filterDataSummaryProcessed}
                      filterDataDetailed={filterDataDetailedProcessed}
                      dateTimeRecordDataSummary={dateTimeRecordDataSummaryProcessed}
                      setDateTimeRecordDataSummary={setDateTimeRecordDataSummaryProcessed}
                      dateTimeRecordDataDetailed={dateTimeRecordDataDetailedProcessed}
                      setDateTimeRecordDataDetailed={setDateTimeRecordDataDetailedProcessed}
                    />
                  </TabPanel>
                  <TabPanel>
                    {/* Posted Time Entries FILTER */}
                    <div className="rounded-lg bg-white p-4 shadow-sm" style={{ border: '1px solid #d1d5db' }}>
                      <div className="py-1">
                        <h4 className="font-medium text-gray-500 mt-0 mb-2">Filter</h4>
                      </div>
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 pb-3 pt-3">
                        <div>
                          <PayTypeSelect
                            label="Pay Type"
                            payTypeId={filterPayTypeId}
                            setPayTypeId={setFilterPayTypeId}
                          />
                          <span style={{
                            visibility: "hidden",
                            color: "#ff6565",
                            fontSize: "12px"
                          }}>Please fill up Pay Type first
                          </span>
                        </div>
                        <div className="">
                          <PayrollPeriodSelect
                            label="Payroll Period"
                            value={filterPayrollPeriodId}
                            setValue={setFilterPayrollPeriodId}
                            hasPayTypeId={true}
                            payTypeId={filterPayTypeId}
                            isDisabled={!filterPayTypeId}
                          />

                          <span style={{
                            visibility: !filterPayTypeId ? "visible" : "hidden",
                            color: "#ff6565",
                            fontSize: "12px"
                          }}>Please fill up Pay Type first
                          </span>
                        </div>
                        {userAccess.length <= 0 &&
                          <div className="">
                            <div className="info-item-label">Classification Type</div>
                            <div className="info-item-input">
                              <ClassificationSelectDummy />
                            </div>
                            <span style={{
                              visibility: "hidden",
                              color: "#ff6565",
                              fontSize: "12px"
                            }}>Please fill up Pay Type first
                            </span>
                          </div>
                        }
                        <div className="">

                          <ClassificationSelect
                            label="Classification"
                            value={filterClassificationId}
                            setValue={setFilterClassificationId}
                            payTypeId={filterPayTypeId}
                            user={user}
                          />

                          <span style={{
                            visibility: !filterPayTypeId ? "visible" : "hidden",
                            color: "#ff6565",
                            fontSize: "12px"
                          }}>Please fill up Pay Type first
                          </span>
                        </div>

                        {FEATURES.TIMEKEEPING_EMPLOYEETYPE && (
                          <div className="">
                            <DepartmentIdSelectWithAll
                              label="Department"
                              value={filterDepartmentId}
                              setValue={setFilterDepartmentId}
                              isEditable={true}
                              disabled={!filterPayTypeId} />

                            <span style={{
                              visibility: !filterPayTypeId ? "visible" : "hidden",
                              color: "#ff6565",
                              fontSize: "12px"
                            }}>Please fill up Pay Type first
                            </span>
                          </div>
                        )}
                        {FEATURES.TIMEKEEPING_EMPLOYEETYPE && (
                          <div className="">
                            <EmployeeTypeIdSelectWithAll
                              label="Employee Type"
                              value={filterEmployeeTypeId}
                              setValue={setFilterEmployeeTypeId}
                              isEditable={true}
                              disabled={!filterPayTypeId} />

                            <span style={{
                              visibility: !filterPayTypeId ? "visible" : "hidden",
                              color: "#ff6565",
                              fontSize: "12px"
                            }}>Please fill up Pay Type first
                            </span>
                          </div>
                        )}
                        {FEATURES.TIMEKEEPING_EMPLOYEETYPE && (
                          <div className="">
                            <VesselIdSelectWithAll
                              label="Vessel"
                              value={filterVesselId}
                              setValue={setFilterVesselId}
                              isEditable={true}
                              disabled={!filterPayTypeId} />

                            <span style={{
                              visibility: !filterPayTypeId ? "visible" : "hidden",
                              color: "#ff6565",
                              fontSize: "12px"
                            }}>Please fill up Pay Type first
                            </span>
                          </div>
                        )}

                      </div>

                      <Button
                        name={"GENERATE"}
                        icon={<RestartAltIcon />}
                        onClick={handleGenerate}
                        className={"bg-blue-800 hover:bg-blue-900 text-white border-none cursor-pointer"}
                      />
                    </div>
                    <PostedTimeEntries
                      filterPayrollPeriodId={filterPayrollPeriodId}
                      filterPayTypeId={filterPayTypeId}
                      filterClassificationId={filterClassificationId}
                      filterLocationId={filterLocationId}
                      filterSectionId={filterSectionId}
                      userAccess={userAccess}
                      isGenerate={isGenerate}
                      isRevert={isRevert}
                      isProcess={isProcess}
                      isPost={isPost}
                      fetchDataSummary={fetchDataSummaryPosted}
                      fetchDataDetailed={fetchDataDetailedPosted}
                      filterDataSummary={filterDataSummaryPosted}
                      filterDataDetailed={filterDataDetailedPosted}
                      loadingSummary={loadingSummaryPosted}
                      loadingDetailed={loadingDetailedPosted}
                      dateTimeRecordDataSummary={dateTimeRecordDataSummaryPosted}
                      setDateTimeRecordDataSummary={setDateTimeRecordDataSummaryPosted}
                      dateTimeRecordDataDetailed={dateTimeRecordDataDetailedPosted}
                      setDateTimeRecordDataDetailed={setDateTimeRecordDataDetailedPosted}
                    />
                  </TabPanel>
                </div>
              </Tabs>

              {(userAccess.description === "Accounting"
                || userAccess.description === "Accounting Head"
                || userAccess.description === "Accounting Assistant") &&
                <div>
                  <b style={{ color: "#668fca" }}>POSTED TIME ENTRIES</b>
                  <div style={{ padding: "10px" }}>
                    <div className='filters-payroll'>
                      <span>Filter</span>
                      <div className="payroll-item-holder info-item-holder row" style={{ justifyContent: "space-evenly", padding: "0 10px 20px 10px" }}>
                        <div className="filter-item-payroll popUp-item info-item column">
                          <div className="info-item-label">Pay Type</div>
                          <div className="info-item-input">
                            <PayTypeIdSelect payTypeId={filterPayTypeId} setPayTypeId={setFilterPayTypeId} />
                          </div>
                          <span style={{
                            visibility: "hidden",
                            color: "#ff6565",
                            fontSize: "12px"
                          }}>Please fill up Pay Type first
                          </span>
                        </div>
                        <div className="filter-item-payroll popUp-item info-item column">
                          <div className="info-item-label">Payroll Period</div>
                          <div className="info-item-input">
                            <PayrollPeriodIdSelectFilter payrollPeriodId={filterPayrollPeriodId} setPayrollPeriodId={setFilterPayrollPeriodId} payTypeId={filterPayTypeId} />
                          </div>
                          <span style={{
                            visibility: !filterPayTypeId ? "visible" : "hidden",
                            color: "#ff6565",
                            fontSize: "12px"
                          }}>Please fill up Pay Type first
                          </span>
                        </div>
                        {userAccess.length <= 0 &&
                          <div className="filter-item-payroll popUp-item info-item column">
                            <div className="info-item-label">Classification Type</div>
                            <div className="info-item-input">
                              <ClassificationIdSelectDummy />
                            </div>
                            <span style={{
                              visibility: "hidden",
                              color: "#ff6565",
                              fontSize: "12px"
                            }}>Please fill up Pay Type first
                            </span>
                          </div>
                        }
                        <div className="filter-item-payroll popUp-item info-item column">
                          <div className="info-item-label">Classification Type</div>
                          <div className="info-item-input">
                            <ClassificationIdSelectFilter user={user} classificationId={filterClassificationId} setClassificationId={setFilterClassificationId} payTypeId={filterPayTypeId} />
                          </div>
                          <span style={{
                            visibility: !filterPayTypeId ? "visible" : "hidden",
                            color: "#ff6565",
                            fontSize: "12px"
                          }}>Please fill up Pay Type first
                          </span>
                        </div>
                      </div>
                      <div className="rightSide-btn" style={{ marginRight: "5px" }}>{CreateButton("", "generate row", handleGenerate, "GENERATE", RestartAltIcon)}</div>
                    </div>
                  </div>
                  <PostedTimeEntries
                    filterPayrollPeriodId={filterPayrollPeriodId}
                    filterPayTypeId={filterPayTypeId}
                    filterClassificationId={filterClassificationId}
                    userAccess={userAccess}
                    isGenerate={isGenerate}
                    isRevert={isRevert}
                    isProcess={isProcess}
                    isPost={isPost}
                    fetchDataSummary={fetchDataSummaryPosted}
                    fetchDataDetailed={fetchDataDetailedPosted}
                    filterDataSummary={filterDataSummaryPosted}
                    filterDataDetailed={filterDataDetailedPosted}
                    loadingSummary={loadingSummaryPosted}
                    loadingDetailed={loadingDetailedPosted}
                    dateTimeRecordDataSummary={dateTimeRecordDataSummaryPosted}
                    setDateTimeRecordDataSummary={setDateTimeRecordDataSummaryPosted}
                    dateTimeRecordDataDetailed={dateTimeRecordDataDetailedPosted}
                    setDateTimeRecordDataDetailed={setDateTimeRecordDataDetailedPosted}
                  />
                </div>
              }
            </div>
          </div>
        </div>
      </div>

      <SelectLogsForm isOpen={showSelectDataLogs}
        onClose={closeSelectDataLogs}
        dateFromLogs={dateFromLogs}
        setDateFromLogs={setDateFromLogs}
        dateToLogs={dateToLogs}
        setDateToLogs={setDateToLogs}
        employeePersonalInformationId={employeePersonalInformationIdLogs}
        setEmployeePersonalInformationId={setEmployeePersonalInformationIdLogs}
        employeePersonalInformationFullName={employeePersonalInformationFullName}
        setEmployeePersonalInformationFullName={setEmployeePersonalInformationFullName}
        deviceLogs={deviceLogs}
        setDeviceLogs={setDeviceLogs}
        setShowEmployeeForm={setShowEmployeeForm}
        classificationFilterForAdminHRHead={classificationFilterForAdminHRHead}
        setClassificationFilterForAdminHRHead={setClassificationFilterForAdminHRHead}
        classificationFilterForHRAsst2={classificationFilterForHRAsst2}
        setClassificationFilterForHRAsst2={setClassificationFilterForHRAsst2}
        classificationFilterForHRAsst3={classificationFilterForHRAsst3}
        setClassificationFilterForHRAsst3={setClassificationFilterForHRAsst3}
        handleSelectDataLogs={handleSelectDataLogs}
        handleSelectDataLogs_Mobile={handleSelectDataLogs_Mobile}
        handleSelectDataLogs_main={handleSelectDataLogs_main}
        userAccessData={userAccess}
        user={user}
      >
      </SelectLogsForm>
      <RevertTimeEntriesForm isOpen={showRevertTimeForm}
        onClose={closeRevertTimeForm}
        fetchUploads={fetchDataTimeEntries}
        fetchProcessedSummary={fetchDataSummaryProcessed}
        fetchProcessedDetailed={fetchDataDetailedProcessed}
        fetchPostedSummary={fetchDataSummaryPosted}
        fetchPostedDetailed={fetchDataDetailedPosted}
        setIsRevert={setIsRevert}
        user={user}

        loadingRequest={loadingRequestProcess}
        setLoadingRequest={setLoadingRequestProcess}
        loadingPercentage={loadingPercentage}
        setLoadingPercentage={setLoadingPercentage}
      >
      </RevertTimeEntriesForm>
      <ProcessTimeEntriesForm isOpen={showProcessTimeForm}
        onClose={closeProcessTimeForm}
        fetchUploads={fetchDataTimeEntries}
        fetchProcessedSummary={fetchDataSummaryProcessed}
        fetchProcessedDetailed={fetchDataDetailedProcessed}
        fetchPostedSummary={fetchDataSummaryPosted}
        fetchPostedDetailed={fetchDataDetailedPosted}
        setIsProcess={setIsProcess}
        user={user}

        loadingRequest={loadingRequestProcess}
        setLoadingRequest={setLoadingRequestProcess}
        loadingPercentage={loadingPercentage}
        setLoadingPercentage={setLoadingPercentage}
      >
      </ProcessTimeEntriesForm>
      <PostTimeEntriesForm isOpen={showPostTimeForm}
        onClose={closePostTimeForm}
        fetchUploads={fetchDataTimeEntries}
        fetchProcessedSummary={fetchDataSummaryProcessed}
        fetchProcessedDetailed={fetchDataDetailedProcessed}
        fetchPostedSummary={fetchDataSummaryPosted}
        fetchPostedDetailed={fetchDataDetailedPosted}
        setIsPost={setIsPost}
        user={user}

        loadingRequest={loadingRequestProcess}
        setLoadingRequest={setLoadingRequestProcess}
        loadingPercentage={loadingPercentage}
        setLoadingPercentage={setLoadingPercentage}
      >
      </PostTimeEntriesForm>
      <DeleteAllForm isOpen={showDeleteAll}
        onClose={closeDeleteAll}
        handleDelete={handleDeleteAll}
      >
      </DeleteAllForm>
      <UploadForm isOpen={showUploadForm}
        onClose={closeUploadFormHandleClick}
        data_temp={uploadTimeEntries}
        setData_temp={setUploadTimeEntries}
        handleFileUpload={handleFileUpload}
        handleFinalFileUpload={handleFinalFileUpload}
      >
      </UploadForm>
      <UploadFormTampered isOpen={showUploadTamperedForm}
        onClose={closeUploadTamperedFormHandleClick}
        data_temp={uploadTamperedEntries}
        setData_temp={setUploadTamperedEntries}
        handleFileUpload={handleFileUploadTampered}
        handleFinalFileUpload={handleFinalFileUploadTampered}
      >
      </UploadFormTampered>
      <EmployeeSelectFormLogs isOpen={showEmployeeForm}
        onClose={closeEmployeeForm}
        setEmployeeId={setEmployeePersonalInformationIdLogs}
        setEmployee={setEmployeePersonalInformationFullName}
      // setEmployeeInfo={setEmployeeInfoLogs}
      >
      </EmployeeSelectFormLogs>
      <GenerateMessage form={generateMessage}
        message={"Please select payroll period, pay type and classification type!"}
        isSuccess={false}
      >
      </GenerateMessage>
      <GenerateMessage form={showRequestMessage}
        message={isSuccess ? "Request Success!" : requestMessage}
        isSuccess={isSuccess}
      >
      </GenerateMessage>
      <GenerateWarningMessage form={showRequestWarningMessage}
        message={"requestWarningMessage"}
      >
      </GenerateWarningMessage>
      {loadingRequest && !loadingRequestProcess ?
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "2000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
        :
        <></>
      }
      {loadingRequestProcess &&
        <CustomLoader loadingPercentage={loadingPercentage} />
      }

      {loadingUploadRequest ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "10000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )
      }
    </div>
  )

}
export default TimeKeeping